

import {
  Box,
  Container,
  Grid,
  Typography,
  Button,
  Stack,
  Chip,
  alpha,
} from '@mui/material';
import WidgetExamplesSection from '../components/WidgetExamplesSection';
import { useNavigate } from 'react-router-dom';
import { ArrowForward } from '@mui/icons-material';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import WidgetTypesSection from '../components/WebWidgetSystemPage';
import { useTenantConfig } from '../hooks/useTenant';
import CustomizationSection from '../components/CustomizationSection';
import VisitorExperience from '../components/VisitorExperience';

const P = {
  main: '#b91010ff',
  light: '#d33434ff',
  dark: '#960505ff',
};

export default function WidgetSystemPage() {
  const { tenantName } = useTenantConfig();
  const navigate = useNavigate();

  const manageData = [
    {
      title: 'Bağışlar',
      desc: 'Panelde tanımlanır, bağış widget’ları ile web sitesinde anlık olarak yayınlanır.',
      note: 'Anlık veri akışı',
      img: '/assets/icon/donation.webp',
    },
    {
      title: 'Projeler',
      desc: 'Projelerinizi, hedef bütçeleri ve ilerleme durumlarıyla birlikte panelde oluşturun, web sitenizde otomatik olarak yayınlansın.',
      note: 'Widget’larla sunulur',
      img: '/assets/icon/project.webp',
    },
    {
      title: 'Faaliyet Alanları',
      desc: 'Yürütülen faaliyetleri kategori bazlı olarak panelde tanımlayın, web sitenizdeki faaliyet widget’larında sergileyin.',
      note: 'Kategori bazlı yönetim',
      img: '/assets/icon/event.webp',
    },
    {
      title: 'Kurumsal İçerikler',
      desc: 'Hakkımızda, iletişim, ekip gibi kurumsal içerikleri panelde oluşturun, web sitenizde ilgili widget’larda gösterilsin.',
      note: 'Kurumsal sayfalar için ideal',
      img: '/assets/icon/association.webp',
    },
    {
      title: 'Banka Bilgileri',
      desc: 'Bağış kabul etmek için gerekli banka bilgilerini panelde tanımlayın, web sitenizdeki bağış widget’larında anında güncellensin.',
      note: 'Güvenli ve hızlı güncelleme',
      img: '/assets/icon/accounting.webp',
    },
    {
      title: 'Haberler & Duyurular',
      desc: 'Derneğinizle ilgili duyuru ve haberleri panelden yönetin, web sitenizde haber widget’ları ile otomatik olarak yayınlayın.',
      note: 'Duyuru ve güncellemeler',
      img: '/assets/icon/bell.webp',
    },
  ]
  return (
    <Box>
      <Box
        sx={{
          pt: { xs: 6, md: 16 },
          pb: { xs: 6, md: 14 },
          background: `linear-gradient(135deg, ${alpha(P.main, 0.06)} 0%, #ffffff 70%)`,
          position: 'relative',
          overflow: 'hidden',
          borderBottom: '1px solid #e5e7eb',
        }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '-20%',
            right: '-10%',
            width: 600,
            height: 600,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${alpha(P.main, 0.08)} 0%, transparent 70%)`,
            filter: 'blur(80px)',
            pointerEvents: 'none',
          }}
        />
        <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 1 }}>
          <Box maxWidth="720px">
            <Chip
              label="WEB SİTESİ & İÇERİK"
              sx={{
                mb: 3,
                fontWeight: 600,
                fontSize: '0.8rem',
                background: alpha(P.main, 0.1),
                color: P.dark,
                border: `1px solid ${alpha(P.main, 0.2)}`,
              }}
            />
            <Typography
              variant="h1"
              sx={{
                fontWeight: 900,
                fontSize: { xs: '2.5rem', md: '3.5rem' },
                mb: 3,
                lineHeight: 1.1,
                color: '#0f172a',
                letterSpacing: '-0.02em',
              }}
            >
              Web Sitenizi ve Panelinizi{' '}
              <Box component="span" sx={{ color: P.main }}>
                Widget'lar ile Yönetin
              </Box>
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: '1.1rem', md: '1.25rem' },
                color: '#64748b',
                lineHeight: 1.7,
                mb: 5,
              }}
            >
              {tenantName}'te web sitesi ve yönetim paneli,
              Widget sistemi bakarak tasarlama ile esnek ama kontrollü şekilde tasarlanır.
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowForward />}
                // onClick={() => navigate('/basvuru')}
                sx={{
                  px: 4,
                  py: 1.5,
                  fontWeight: 700,
                  fontSize: '1rem',
                  background: `linear-gradient(135deg, ${P.main} 0%, ${P.dark} 100%)`,
                  boxShadow: `0 8px 24px ${alpha(P.main, 0.35)}`,
                  '&:hover': {
                    background: `linear-gradient(135deg, ${P.dark} 0%, #047857 100%)`,
                    boxShadow: `0 12px 32px ${alpha(P.main, 0.45)}`,
                  },
                }}
              >
                Hemen Başlayın
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>

      {/* 2️⃣ TEK MERKEZDEN YÖNETİM */}
      <ManageSection manageData={manageData} />
      {/* 3️⃣ ESNEKLİK — Her Dernek Aynı Değil */}
      <FlexibilitySection />
      {/* 4️⃣ VERİ AKIŞI VE KATEGORİLER */}
      <WidgetTypesSection />
      
      <CustomizationSection/>
      <VisitorExperience/>
      {/* <WidgetCustomizationSection /> */}

      <WidgetExamplesSection />

      {/* 4️⃣ CTA */}
      <Box
        sx={{
          py: { xs: 8, md: 12 },
          background: '#f8fafc',
        }}
      >
        <Container maxWidth="lg">
          <Box
            sx={{
              background: `linear-gradient(135deg, ${P.main} 0%, ${P.light} 50%, ${P.dark} 100%)`,
              color: 'white',
              position: 'relative',
              overflow: 'hidden',
              borderRadius: 4,
              py: { xs: 6, md: 8 },
              px: { xs: 3, md: 6 },
            }}
          >
            {/* Arka plan deseni */}
            <Box
              sx={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                opacity: 0.15,
                backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)',
                backgroundSize: '30px 30px'
              }}
            />

            {/* Decorative circles */}
            <Box
              sx={{
                position: 'absolute',
                top: '-10%',
                right: '-5%',
                width: 400,
                height: 400,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.1)',
                filter: 'blur(60px)',
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                bottom: '-10%',
                left: '-5%',
                width: 300,
                height: 300,
                borderRadius: '50%',
                background: 'rgba(255,255,255,0.08)',
                filter: 'blur(50px)',
              }}
            />

            <Box sx={{ position: 'relative', textAlign: 'center', maxWidth: '800px', mx: 'auto' }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { xs: '1.75rem', md: '2.5rem' },
                  fontWeight: 900,
                  mb: 3,
                  textShadow: '0 2px 10px rgba(0,0,0,0.1)'
                }}
              >
               Web Sitenizi Siz Yönetin, Veriyi {tenantName} Beslesin
              </Typography>

              <Typography
                sx={{
                  fontSize: { xs: '1.05rem', md: '1.2rem' },
                  mb: 5,
                  opacity: 0.95,
                  maxWidth: '580px',
                  mx: 'auto',
                  lineHeight: 1.7,
                  color: 'rgba(255,255,255,0.9)'
                }}
              >
              {tenantName} Widget Sistemi ile web sitenizi tasarlamakla uğraşmaz, yönetirsiniz.
              </Typography>

              <Stack
                direction={{ xs: 'column', sm: 'row' }}
                spacing={3}
                justifyContent="center"
              >
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => navigate('/basvuru')}
                  sx={{
                    bgcolor: 'white',
                    color: P.main,
                    px: 5,
                    py: 2,
                    fontSize: '1.05rem',
                    fontWeight: 700,
                    boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
                    '&:hover': {
                      bgcolor: '#fafafa',
                      transform: 'translateY(-3px)',
                      boxShadow: '0 8px 30px rgba(0,0,0,0.2)'
                    }
                  }}
                >
                  Hemen Başvurun
                </Button>
                <Button
                  variant="outlined"
                  size="large"
                  onClick={() => navigate('/iletisim')}
                  sx={{
                    borderColor: 'white',
                    color: 'white',
                    px: 5,
                    py: 2,
                    fontSize: '1.05rem',
                    fontWeight: 700,
                    borderWidth: 2,
                    backdropFilter: 'blur(10px)',
                    background: 'rgba(255,255,255,0.1)',
                    '&:hover': {
                      borderColor: 'white',
                      borderWidth: 2,
                      bgcolor: 'rgba(255,255,255,0.2)',
                      transform: 'translateY(-3px)',
                      boxShadow: '0 8px 25px rgba(0,0,0,0.15)'
                    }
                  }}
                >
                  İletişime Geçin
                </Button>
              </Stack>

            </Box>
          </Box>
        </Container>
      </Box>
    </Box>
  );
}



function ManageSection({ manageData }) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <Box
      ref={ref}
      sx={{
        py: { xs: 3, md: 14 },
        background: '#ffffff',
        borderTop: '1px solid #f1f5f9',
      }}
    >
      <Container maxWidth="lg">

        {/* Başlık */}
        <motion.div variants={fadeUp} initial="hidden" animate={isInView ? 'visible' : 'hidden'}>
          <Box textAlign="center" mb={{ xs: 6, md: 8 }}>
            <Typography
              variant="h3" fontWeight={700} mb={2} color="#0f172a"
            >
              Tüm İçerikler
              <br />
              Tek Panelden Yönetilir
            </Typography>
            <Typography sx={{
              fontSize: '1.05rem',
              color: '#475569',
              lineHeight: 1.8,
              mb: 4,
            }}>
              Panelde oluşturduğunuz her veri, widget'lar aracılığıyla
              web sitenizde otomatik olarak kullanılır.
            </Typography>
          </Box>
        </motion.div>

        {/* Kartlar */}
        <Grid container spacing={2.5}>
          {manageData.map((item, i) => (
            <Grid item xs={12} sm={6} md={4} key={item.title}>
              <motion.div
                variants={fadeUp}
                custom={i}
                initial="hidden"
                animate={isInView ? 'visible' : 'hidden'}
                style={{ height: '100%' }}
              >
                <Box
                  sx={{
                    p: 3, borderRadius: 2.5, height: '100%',
                    background: '#ffffff',
                    border: '1px solid #e5e7eb',
                    flexDirection: 'column',
                    display: 'flex', alignItems: 'flex-start', gap: 2.5,
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    cursor: 'pointer',
                    position: 'relative',
                    overflow: 'hidden',
                    '&::before': {
                      content: '""',
                      position: 'absolute',
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      opacity: 0,
                      transition: 'opacity 0.4s ease',
                      zIndex: 0,
                    },
                    '&:hover': {
                      background: '#fff',
                      borderColor: P.main,
                      transform: 'translateY(-8px) scale(1.02)',
                      '&::before': {
                        opacity: 1,
                      },
                      '& .icon-img': {
                        transform: 'scale(1.1)',
                      },
                    },
                  }}
                >
                  {/* Görsel */}
                  <Box className="icon-box" sx={{
                    width: 62, height: 62, flexShrink: 0,
                    borderRadius: 2,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    overflow: 'hidden',
                    background: `linear-gradient(135deg, rgb(255 0 0 / 64%) 0%, rgb(171 4 4) 100%)`,
                    border: `1.5px solid ${alpha(P.main, 0.2)}`,
                    transition: 'all 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                    position: 'relative',
                    zIndex: 1,
                  }}>
                    <Box
                      component="img"
                      src={item.img}
                      alt={item.title}
                      className="icon-img"
                      sx={{ 
                        width: 45, 
                        height: 45, 
                        objectFit: 'contain',
                        transition: 'transform 0.4s cubic-bezier(0.4, 0, 0.2, 1)',
                        filter:'brightness(0) invert(1) sepia(1) hue-rotate(200deg) saturate(300%)',
                      }}
                    />
                  </Box>

                  {/* İçerik */}
                  <Box sx={{ flex: 1, minWidth: 0, position: 'relative', zIndex: 1 }}>
                    <Typography sx={{
                      fontWeight: 700, fontSize: '0.95rem',
                      color: '#0f172a', mb: 0.75, lineHeight: 1.3,
                    }}>
                      {item.title}
                    </Typography>
                    <Typography sx={{
                      fontSize: '0.83rem', color: '#64748b', lineHeight: 1.65,
                    }}>
                      {item.desc}
                    </Typography>
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        {/* Alt özet şerit */}
        <motion.div variants={fadeUp} custom={7} initial="hidden" animate={isInView ? 'visible' : 'hidden'}>
          <Box sx={{
            mt: 6, py: 2.5, px: 3, borderRadius: 2.5,
            background: `linear-gradient(135deg, ${alpha(P.main, 0.01)} 0%, ${alpha(P.light, 0.04)} 100%)`,
            border: `1.5px solid ${alpha(P.main, 0.25)}`,
            display: 'flex', alignItems: 'center', gap: 2,
            flexDirection: { xs: 'column', sm: 'row' },
            textAlign: { xs: 'center', sm: 'center' },
            position: 'relative',
            overflow: 'hidden',
            justifyContent: 'center',
          }}>
            <Box
              component="img"
              src="/assets/icon/dashboard.webp"
              alt="panel"
              className="summary-icon"
              sx={{ 
                width: 36, 
                height: 36, 
                objectFit: 'contain', 
                flexShrink: 0,
                filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.1))',
                position: 'relative',
                zIndex: 1,
              }}
            />
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <Typography sx={{ 
                fontWeight: 700, 
                fontSize: '0.9rem', 
                color: '#0f172a', 
                mb: 0.2,
                textShadow: '0 1px 2px rgba(0,0,0,0.02)',
              }}>
                Panelde bir kez güncelle — her yerde anında yansısın
              </Typography>
              <Typography sx={{ fontSize: '0.82rem', color: '#64748b' }}>
                Web sitenizde manuel güncelleme gerekmez. Tüm veri akışı otomatiktir.
              </Typography>
            </Box>
          </Box>
        </motion.div>

      </Container>
    </Box>
  )
}

function FlexibilitySection() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <Box
      ref={ref}
      sx={{
        py: { xs: 8, md: 14 },
        background: '#f8fafc',
        borderTop: '1px solid #f1f5f9',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 6, md: 10 }} alignItems="center">

          {/* Sol: Metin */}
          <Grid item xs={12} md={6}>
            <motion.div
              variants={{ hidden: { opacity: 0, x: -40 }, visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] } } }}
              initial="hidden"
              animate={isInView ? 'visible' : 'hidden'}
            >
              <Typography variant="h3" fontWeight={700} mb={2} color="#0f172a">
                Her Dernek Aynı Değil,
                <br />
                <Box component="span" sx={{
                  background: "linear-gradient(135deg, #490101 0%, #d33434ff 100%)",
                  WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
                }}>
                  Web Siteniz de Olmasın
                </Box>
              </Typography>

              <Typography sx={{
                fontSize: '1rem', color: '#475569', lineHeight: 1.8, mb: 4, maxWidth: 500,
              }}>
                Standart şablonlar ve sabit paneller derneklerin ihtiyaçlarını karşılamakta
                yetersiz kalır. Widget sistemi ile her yapı kendi dilini oluşturur.
              </Typography>

              <Stack spacing={1.5}>
                <FlexFeature img="/assets/icon/flexibility.webp" text="Bakarak tasarlama ile kolay düzenleme" />
                <FlexFeature img="/assets/icon/window.webp" text="Her sayfaya özel içerik alanları" />
                <FlexFeature img="/assets/icon/internet.webp" text="Mobil uyumlu responsive tasarım" />
                <FlexFeature img="/assets/icon/efficiency.webp" text="Anlık önizleme ve yayınlama" />
              </Stack>
            </motion.div>
          </Grid>

          {/* Sağ: Widget Mozaiği */}
          <Grid item xs={12} md={6}>
            <motion.div
              variants={{ hidden: { opacity: 0, x: 40 }, visible: { opacity: 1, x: 0, transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.15 } } }}
              initial="hidden"
              animate={isInView ? 'visible' : 'hidden'}
            >
              <Box sx={{
                borderRadius: 3, overflow: 'hidden',
                border: '1px solid #e2e8f0',
                background: '#fff',
                boxShadow: '0 4px 24px rgba(0,0,0,0.06)',
              }}>
                {/* Sahte browser bar */}
                <Box sx={{
                  px: 2, py: 1.25, background: '#f1f5f9',
                  borderBottom: '1px solid #e2e8f0',
                  display: 'flex', alignItems: 'center', gap: 1,
                }}>
                  <Box sx={{ display: 'flex', gap: 0.6 }}>
                    {['#ff5f57', '#ffbd2e', '#28c840'].map((c, i) => (
                      <Box key={i} sx={{ width: 9, height: 9, borderRadius: '50%', bgcolor: c }} />
                    ))}
                  </Box>
                  <Box sx={{
                    flex: 1, ml: 1.5, px: 1.5, py: 0.4, borderRadius: 1,
                    background: '#fff', border: '1px solid #e2e8f0',
                    fontSize: '0.7rem', color: '#94a3b8',
                  }}>
                    🔒 www.dernegim.com/anasayfa
                  </Box>
                </Box>

                {/* Widget grid alanı */}
                <Box sx={{ p: 2.5 }}>
                  <Typography sx={{
                    fontSize: '0.7rem', fontWeight: 600, color: '#94a3b8',
                    mb: 1.5, textTransform: 'uppercase', letterSpacing: '0.6px',
                  }}>
                    Sayfa Düzeni
                  </Typography>
                  <Box sx={{
                    display: 'flex', flexWrap: 'wrap', gap: 1,
                  }}>
                    <WidgetBlock label="Bağış Widget'ı" img="/assets/icon/donation.webp" />
                    <WidgetBlock label="Proje Listesi" img="/assets/icon/project.webp" />
                    <WidgetBlock label="Duyuru Alanı" img="/assets/icon/bell.webp" />
                    <WidgetBlock label="Faaliyet Bloku" img="/assets/icon/event.webp" />
                    <WidgetBlock label="Kurumsal Bilgi" img="/assets/icon/association.webp" />
                    <WidgetBlock label="İstatistik" img="/assets/icon/chart.webp" />
                  </Box>

                  {/* Alt bilgi bandı */}
                  <Box sx={{
                    mt: 2.5, py: 1.5, px: 2, borderRadius: 1.5,
                    background: alpha(P.main, 0.06),
                    border: `1px solid ${alpha(P.main, 0.15)}`,
                    display: 'flex', alignItems: 'center', gap: 1.5,
                  }}>
                    <Box component="img" src="/assets/icon/dashboard.webp"
                      sx={{ width: 24, height: 24, objectFit: 'contain' }} />
                    <Typography sx={{ fontSize: '0.78rem', color: '#475569', fontWeight: 500 }}>
                      Widget'lar panelden yönetilir, web sitesine anında yansır.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </motion.div>
          </Grid>

        </Grid>
      </Container>
    </Box>
  );
}

function FlexFeature({ img, text }) {
  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 1.75,
      py: 1.25, px: 1.75, borderRadius: 2,
      background: '#fff', 
      border: '1px solid #e5e7eb',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      cursor: 'pointer',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(90deg, ${alpha(P.main, 0.04)} 0%, ${alpha(P.light, 0.06)} 100%)`,
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover': { 
        borderColor: P.main,
        transform: 'translateX(8px)',
        boxShadow: `0 4px 16px ${alpha(P.main, 0.12)}`,
        '&::before': {
          opacity: 1,
        },
        '& .flex-icon-box': {
          transform: 'scale(1.15) rotate(-5deg)',
          background: `linear-gradient(135deg, ${alpha(P.main, 0.15)} 0%, ${alpha(P.light, 0.12)} 100%)`,
          borderColor: P.main,
        },
      },
    }}>
      <Box className="flex-icon-box" sx={{
        width: 36, height: 36, flexShrink: 0,
        borderRadius: 1.5,
        background: `linear-gradient(135deg, ${alpha(P.main, 0.08)} 0%, ${alpha(P.light, 0.05)} 100%)`,
        border: `1px solid ${alpha(P.main, 0.15)}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        zIndex: 1,
      }}>
        <Box component="img" src={img} alt="" sx={{ 
          width: 22, 
          height: 22, 
          objectFit: 'contain',
          filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.08))',
        }} />
      </Box>
      <Typography sx={{ 
        fontSize: '0.9rem', 
        fontWeight: 600, 
        color: '#334155',
        position: 'relative',
        zIndex: 1,
      }}>
        {text}
      </Typography>
    </Box>
  );
}

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: (i = 0) => ({
    opacity: 1, y: 0,
    transition: { duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.09 },
  }),
};


function WidgetBlock({ label, img }) {
  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', gap: 1,
      px: 1.5, py: 1, borderRadius: 1.5,
      border: '1px solid #e2e8f0',
      background: `linear-gradient(135deg, #fafafa 0%, #ffffff 100%)`,
      cursor: 'grab',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      position: 'relative',
      overflow: 'hidden',
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: `linear-gradient(135deg, ${alpha(P.main, 0.05)} 0%, ${alpha(P.light, 0.08)} 100%)`,
        opacity: 0,
        transition: 'opacity 0.3s ease',
      },
      '&:hover': {
        background: '#fff',
        borderColor: P.main,
        boxShadow: `0 4px 16px ${alpha(P.main, 0.15)}`,
        transform: 'translateY(-4px) scale(1.05)',
        '&::before': {
          opacity: 1,
        },
        '& .widget-icon': {
          transform: 'scale(1.2) rotate(5deg)',
        },
      },
    }}>
      <Box component="img" src={img} alt="" className="widget-icon" sx={{ 
        width: 20, 
        height: 20, 
        objectFit: 'contain',
        transition: 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        zIndex: 1,
        filter: 'drop-shadow(0 1px 2px rgba(0,0,0,0.1))',
      }} />
      <Typography sx={{ 
        fontSize: '0.75rem', 
        fontWeight: 600, 
        color: '#475569', 
        whiteSpace: 'nowrap',
        position: 'relative',
        zIndex: 1,
      }}>
        {label}
      </Typography>
      <Box sx={{ 
        ml: 0.5, 
        color: '#94a3b8', 
        fontSize: '0.7rem', 
        lineHeight: 1,
        position: 'relative',
        zIndex: 1,
      }}>⠿</Box>
    </Box>
  );
}


